export const treeData = [
    {
        label: 'Terms',
        id: 'terms-and-conditions',
        inHouse: true,
        children: [
            {
                label: 'General',
                id: 'general',
                anchor: true
            },
            {
                label: 'Registration & Eligibility',
                id: 'registration',
                anchor: true
            },
            {
                label: 'Services',
                id: 'services',
                anchor: true
            },
            {
                label: 'DevNet Privacy Addendum',
                id: 'privacy',
                anchor: true
            },
            {
                label: 'DevNet Licensing Addendum',
                id: 'addendum',
                anchor: true
            },
            {
                label: 'Disclaimer and Limitation on Liability',
                id: 'disclaimer',
                anchor: true
            },
            {
                label: 'Changes to This Agreement',
                id: 'changes',
                anchor: true
            },
        ]
    },
    // {
    //     label: 'Updates',
    //     id: 'updates',
    //     children: []
    // },
    {
        label: 'Additional terms',
        id: 'additional-item',
        page: "AdditionalPage",
        children: [
            {
                label: 'Protected content',
                id: 'protected-content',
                children: [
                    {
                        label: 'CISCO DNA-LTX TAGS PROTOCOL SPECIFICATIONS SUPPLEMENTAL TERMS',
                        id: 'dna-ltx-file-term',
                        inHouse: true,
                    }, {
                        label: 'Cisco Systems NSO DevNet Download Agreement',
                        id: 'nso-file-term',
                        inHouse: true,
                    }, {
                        label: 'Strong Encryption Eligibility - Cisco Systems Inc. Encryption Software Usage Handling and Distribution Policy',
                        id: 'ise-file-term',
                        inHouse: true,
                    }, {
                        label: 'Software Development Kit License Agreement',
                        id: 'dna-file-term',
                        inHouse: true,
                    }, {
                        label: 'Tail-f ConfD Basic License Agreement',
                        id: 'confd-file-term',
                        inHouse: true,
                    },
                ]
            },
            {
                label: 'Study Group',
                id: 'study-group',
                children: [
                    {
                        label: 'Cisco DevNet Study Group Beta Trial Agreement',
                        id: 'cisco-devnet-study-group-beta-trial-agreement',
                        inHouse: true,
                    },
                    {
                        label: 'POSTING GUIDELINES QUICK REFERENCE/ACCEPTABLE USE AGREEMENT',
                        id: 'posting-guidelines-quick-reference-acceptable-use-agreement',
                        inHouse: true,
                    },
                ]
            },
            {
                label: 'Certification',
                id: 'certification',
                page: 'CertificationPage'
            },
            {
                label: 'Other',
                id: 'other',
                children: [
                    {
                        label: 'Cisco API License',
                        id: 'cisco-api-license',
                        inHouse: true,
                    },
                    {
                        label: 'Cisco Sample Code License',
                        id: 'cisco-sample-code-license',
                        inHouse: true,
                    },
                ]
            },
        ]
    }
];

